// isyatirim.com.tr'ye tarayıcıdan doğrudan istek CORS nedeniyle
// engellendiği için sunucu tarafındaki proxy'ye (server/index.js) istek
// atıyoruz; o da isyatirim.com.tr'den veriyi çekip "last" ve "updateDate"
// alanlarını döndürüyor. kaldir_server ayrı bir domain/portta çalıştığından
// (bkz. REACT_APP_API_BASE_URL) adres mutlak veriliyor.
const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

// isyatirim.com.tr saat dilimini "+03" gibi dakikasız veriyor; bu ISO-8601
// olarak geçerli olmadığından Date bunu ayrıştıramıyor, ":00" ekleyip
// düzeltiyoruz.
function tarihiAyristir(deger) {
  if (!deger) return null;
  const duzeltilmis = deger.replace(/([+-]\d{2})$/, '$1:00');
  const tarih = new Date(duzeltilmis);
  return Number.isNaN(tarih.getTime()) ? null : tarih;
}

export async function sonFiyatGetir(kod) {
  const response = await fetch(`${API_BASE}/api/fiyat/${encodeURIComponent(kod)}`, {
    headers: { Accept: 'application/json' }
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'HTTP ' + response.status);
  }

  return {
    last: veri.last,
    dayClose: veri.dayClose,
    // isyatirim.com.tr'nin verdiği güncelleme zamanı; tarayıcının fiyatı
    // aldığı an değil, borsadaki gerçek son fiyat zamanı gösterilsin diye.
    guncellemeZamani: tarihiAyristir(veri.updateDate)
  };
}

// Birden fazla hisse kodu için anlık fiyatı tek seferde (paralel istekler
// halinde) çeker; sürekli açık bir bağlantı tutmaz, yalnızca çağrıldığı an
// için bir anlık görüntü döner (bkz. takip-listem.jsx/alim-satim.jsx'teki
// "Yenile" düğmesi). Bir kod başarısız olursa diğerlerini etkilemez, o kod
// için "hata" alanı doldurulur.
export async function birdenFazlaFiyatGetir(kodlar) {
  const sonuclar = await Promise.all(kodlar.map(async kod => {
    try {
      const veri = await sonFiyatGetir(kod);
      return [kod, { ...veri, hata: '' }];
    } catch (err) {
      return [kod, { hata: err.message || 'Fiyat alınamadı' }];
    }
  }));

  return Object.fromEntries(sonuclar);
}

// Sürekli GET isteği atmak yerine tek bir SSE bağlantısı açar; sunucu
// (server/index.js: /api/fiyat-stream) verilen kodları arka planda
// periyodik kontrol edip fiyat gerçekten değiştiğinde (ilk bağlantıdaki
// değer dahil) yalnızca o zaman event gönderir. Dönen fonksiyon
// bağlantıyı kapatır (useEffect temizleme fonksiyonu olarak kullanılabilir).
export function fiyatAkisiAc(kodlar, kodGuncellendi) {
  if (!kodlar || kodlar.length === 0) return () => {};

  const kaynak = new EventSource(`${API_BASE}/api/fiyat-stream?kodlar=${encodeURIComponent(kodlar.join(','))}`);

  kaynak.addEventListener('fiyat', event => {
    const veri = JSON.parse(event.data);
    kodGuncellendi(veri.kod, {
      last: veri.last,
      dayClose: veri.dayClose,
      guncellemeZamani: tarihiAyristir(veri.updateDate)
    });
  });

  return () => kaynak.close();
}

export async function gecmisFiyatGetir(kod) {
  const response = await fetch(`${API_BASE}/api/gecmis-fiyat/${encodeURIComponent(kod)}`, {
    headers: { Accept: 'application/json' }
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'HTTP ' + response.status);
  }

  return veri.veri.map(nokta => ({ tarih: new Date(nokta.tarih), kapanis: nokta.kapanis }));
}
